import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
  CustomInput,
  FormGroup,
} from 'reactstrap';
import {Form as FinalForm} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import TextField from '../../../../components/TextField';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {NotificationManager} from '../../../../components/common/react-notifications';
import LoaderButton from '../../../../components/LoaderButton';
import Api from '../../../../services/Api';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {difference} from '../../../../helpers/Utils';
import 'rc-switch/assets/index.css';

class Update extends Component {
  constructor(props) {
    super(props);
    const {mode, transport} = props.location.state;
    this.state = {
      mode,
      transport,
    };
  }

  updateMailTransport = async values => {
    const {t} = this.props;
    const {transport} = this.state;
    try {
      await Api.invoke('PUT', '/admin-ui/mail-transport', {
        mailTransport: JSON.stringify(difference(values, transport)),
      });
      NotificationManager.success(t('Mail server updated successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  updateMailgunTransport = async values => {
    const {t} = this.props;
    const {transport} = this.state;
    try {
      await Api.invoke('PUT', '/admin-ui/mailgun-transport', {
        mailgunTransport: JSON.stringify(difference(values, transport)),
      });
      NotificationManager.success(t('Mail server updated successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  getMailTextFields = t => [
    {
      name: 'host',
      i18n: t('Host'),
      type: 'text',
      required: true,
    },
    {
      name: 'port',
      i18n: t('Port'),
      type: 'text',
      required: true,
    },
    {
      name: 'user',
      i18n: t('User'),
      type: 'text',
      required: true,
    },
    {
      name: 'pass',
      i18n: t('New Password'),
      type: 'password',
    },
  ];

  getMailgunTextFields = t => [
    {
      name: 'domain',
      i18n: t('Domain'),
      type: 'text',
      required: true,
    },
    {
      name: 'from',
      i18n: t('Transmitter'),
      type: 'text',
      required: true,
    },
    {
      name: 'apiKey',
      i18n: t('New API Key'),
    },
  ];

  onSelectMailgun = async () => {
    this.setState({
      mode: 'mailgun',
    });
    try {
      await Api.invoke('PUT', '/admin-ui/mailgun-transport', {
        mailgunTransport: JSON.stringify({enabled: true}),
      });
      const {data} = await Api.invoke('GET', '/admin-ui/mailgun-transport');
      this.setState({
        transport: data,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  onSelectSMTP= async () => {
    this.setState({
      mode: 'smtp',
    });
    try {
      await Api.invoke('PUT', '/admin-ui/mailgun-transport', {
        mailgunTransport: JSON.stringify({enabled: false}),
      });
      const {data} = await Api.invoke('GET', '/admin-ui/mail-transport');
      this.setState({
        transport: data,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  render() {
    const {t, match} = this.props;
    const {mode, transport} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Update Mail Server')}
                </CardTitle>
                <FormGroup className='d-flex flex-row align-items-center'>
                  <CustomInput
                    id="smtp"
                    type="radio"
                    name="customRadio"
                    label={t('SMTP Service')}
                    checked={mode === 'smtp'}
                    onChange={this.onSelectSMTP}
                  />
                  <CustomInput
                    type="radio"
                    id="mailgun"
                    className='mx-4'
                    name="customRadio"
                    label={t('Mailgun Service')}
                    checked={mode === 'mailgun'}
                    onChange={this.onSelectMailgun}
                  />
                </FormGroup>
                <FinalForm
                  initialValues={{...transport}}
                  onSubmit={mode !== 'mailgun' ? this.updateMailTransport : this.updateMailgunTransport}
                  render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        {mode !== 'mailgun' ?
                          this.getMailTextFields(t).map((item, index) => (
                            <Row key={index}>
                              <Col className='col-lg-6 col-md-12'>
                                <TextField item={item} />
                              </Col>
                            </Row>
                          )) :
                          this.getMailgunTextFields(t).map((item, index) => (
                            <Row key={index}>
                              <Col className='col-lg-6 col-md-12'>
                                <TextField item={item} />
                              </Col>
                            </Row>
                          ))
                        }
                        <LoaderButton
                          loading={submitting}
                          onClick={handleSubmit}
                          disabled={pristine || hasValidationErrors || submitting}
                          className="mt-4 text-center"
                          style={{minWidth: '100px'}}>
                          {t('Save')}
                        </LoaderButton>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Update);
